import { render, staticRenderFns } from "./ProgramGenreEdit.vue?vue&type=template&id=81f3bb92&scoped=true&"
import script from "./ProgramGenreEdit.vue?vue&type=script&lang=js&"
export * from "./ProgramGenreEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProgramGenreEdit.vue?vue&type=style&index=0&id=81f3bb92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f3bb92",
  null
  
)

export default component.exports